/** Sin acentos, minúsculas — p. ej. "Médico" → "medico". */
export const foldForRoleMatch = value =>
    String(value ?? '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();

export const getRoleNameFromUser = user =>
    foldForRoleMatch(
        user?.role_global ||
        user?.role_name ||
        user?.rol_nombre ||
        user?.role?.nombre ||
        user?.Role?.nombre ||
        user?.rol ||
        (typeof user?.role === 'string' ? user.role : '') ||
        ''
    );

export const getRoleIdFromUser = user => {
    const raw = user?.role_id ?? user?.roleId ?? user?.role?.id ?? user?.Role?.id ?? user?.rol_id ?? user?.role;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : 0;
};

export const isAdminOrSuperAdmin = user => {
    const roleName = getRoleNameFromUser(user);
    const roleId = getRoleIdFromUser(user);

    if ([1, 2].includes(roleId)) {
        return true;
    }

    return (
        roleName.includes('super') ||
        roleName.includes('admin') ||
        roleName === 'superadmin' ||
        roleName === 'super_admin'
    );
};

export const isSuperAdminRoleName = roleName => {
    const folded = foldForRoleMatch(roleName);

    return (
        folded.includes('super') ||
        folded === 'superadmin' ||
        folded === 'super_admin'
    );
};

export const isSuperAdmin = user => {
    const roleName = getRoleNameFromUser(user);
    const roleId = getRoleIdFromUser(user);

    if (roleId === 1) {
        return true;
    }

    return isSuperAdminRoleName(roleName);
};

export const isDoctorRole = user => {
    const roleName = getRoleNameFromUser(user);
    const roleId = getRoleIdFromUser(user);

    return roleName.includes('doctor') || roleName.includes('medico') || roleId === 3;
};

/** Médico, Admin y SuperAdmin comparten el formulario extendido de perfil. */
export const hasExtendedProfileForm = user =>
    isDoctorRole(user) || isAdminOrSuperAdmin(user);

export const isStandardUserRole = user => {
    if (isAdminOrSuperAdmin(user) || isDoctorRole(user)) {
        return false;
    }

    const roleName = getRoleNameFromUser(user);
    const roleId = getRoleIdFromUser(user);

    if (roleName === 'user' || roleName === 'usuario') {
        return true;
    }

    return roleId === 4;
};
